import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/mnemonics",
      },
      queries: [],
    }),
    [],
  );
}

export const useMnemonicsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
